import React from 'react';
import {inject, observer} from 'mobx-react';
import {Modal} from 'antd';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

import WeaThemeCenter from  '../../../../portal4public/wea-theme-center';

@inject('portalThemeStore')
@observer
class E8LeftMenuBottom extends React.Component {
    constructor(props) {
        super(props);
        this.onShowThemeCenter = this.onShowThemeCenter.bind(this);
    }

    render() {
        const {portalThemeStore} = this.props;

        return (
            <div className="e8left-lmb">
                <WeaThemeCenter ref="WeaThemeCenter"/>
                <div className="e8left-lmb-item e8left-lmb-personal" onClick={() => portalThemeStore.onLoadMain({mobxrouteurl: '/customsetting'})}></div>
                <div className="e8left-lmb-item e8left-lmb-password" onClick={() => portalThemeStore.onLoadMain({mobxrouteurl: '/hrm/password'})}></div>
                <div className="e8left-lmb-item e8left-lmb-skin" onClick={this.onShowThemeCenter}></div>
            </div>
        );
    }

    onShowThemeCenter() {
        const {portalThemeStore} = this.props;
        const {themeInfo = {}} = portalThemeStore;

        if (themeInfo.themeAppoint) {
            Modal.confirm({
                title: getLabel(15172, '系统提示'),
                content: getLabel(126325, '分部已指定主题模板，不能修改!')
            });
        } else {
            this.refs['WeaThemeCenter'].onShow();
        }
    }
}

export default E8LeftMenuBottom;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8LeftMenuBottom.js